import SEO from "../../../data/seo";
import HeaderTwo from "../../../layout/headers/header-two";
import BreadCrumb from "../../common/breadcrumb";
import FooterOne from "../../../layout/footers/footer-one";
import FourColumns from "./four-columns";

const PortfolioFourColumns = () => {
    return (
        <>
            <SEO pageTitle="Compact Grid | Arclight Developers" />
            <HeaderTwo />
            <BreadCrumb title="Compact Grid" innerTitle="Compact Grid" />
            <FourColumns />
            <FooterOne />    
        </>
    );
};

export default PortfolioFourColumns;